var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnDemand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4815 0H3.14816C2.31312 0 1.5127 0.331336 0.9224 0.9224C0.331336 1.51268 0 2.31308 0 3.14816V11.3333C0 12.1684 0.331336 12.9688 0.9224 13.5591C1.51268 14.1502 2.31308 14.4815 3.14816 14.4815H8.18519V15.7407H6.92593C6.57805 15.7407 6.2963 16.0225 6.2963 16.3704C6.2963 16.7183 6.57805 17 6.92593 17H10.7037C11.0516 17 11.3333 16.7183 11.3333 16.3704C11.3333 16.0225 11.0516 15.7407 10.7037 15.7407H9.44444V14.4815H14.4815C15.3165 14.4815 16.1169 14.1502 16.7072 13.5591C17.2983 12.9688 17.6296 12.1684 17.6296 11.3333V3.14816C17.6296 2.31312 17.2983 1.5127 16.7072 0.9224C16.1169 0.331336 15.3165 0 14.4815 0ZM16.3704 11.3333C16.3704 12.3761 15.5243 13.2222 14.4815 13.2222H3.14816C2.10534 13.2222 1.25928 12.3761 1.25928 11.3333V3.14814C1.25928 2.10532 2.10534 1.25926 3.14816 1.25926H14.4815C15.5243 1.25926 16.3704 2.10532 16.3704 3.14814V11.3333Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.806152,
    y: 0.352661,
    width: 16.1185,
    height: 13.7007,
    rx: 3,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0626 7.08325L7.91446 4.87945C7.72635 4.75509 7.48631 4.74093 7.28483 4.84167C7.07785 4.9487 6.9464 5.16198 6.94483 5.39574V9.80314C6.94404 10.0385 7.07548 10.2549 7.28483 10.3635C7.37376 10.4115 7.47372 10.4351 7.57446 10.4328C7.70274 10.4328 7.82788 10.3926 7.93333 10.3194L11.0815 8.11562C11.2507 7.99836 11.3522 7.80552 11.3522 7.59933C11.3475 7.38997 11.2389 7.19637 11.0626 7.08303V7.08325ZM8.18525 8.59435V6.60473L9.60821 7.59954L8.18525 8.59435Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnDemand);
export default __webpack_public_path__ + "static/media/on-demand.cd93dcf4d38842ac249e5d897e719e44.svg";
export { ForwardRef as ReactComponent };